import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const paqueteService = {
  getAll,
  getByIdPaquete,
  guardarPaquete,
  deleteHitoPaqueteByIdAndTipoHito,
  deleteById,
}

async function getAll() {
  return await ApiBudgety.get('Paquete/GetAll/')
}

async function getByIdPaquete(id) {
  return await ApiBudgety.get('Paquete/FindByIdPaquete/' + id)
}

async function guardarPaquete(paquete) {
  return await ApiBudgety.post('Paquete/InsertOrUpdate/', paquete, {
    headers: {
      ACCION: MenusSistema.mantenedor_hito.accesos.crear_editar_grupo_hito,
      MENU: MenusSistema.mantenedor_hito.id,
    },
  })
}

async function deleteHitoPaqueteByIdAndTipoHito(idPresupuesto, idTipoHito) {
  return await ApiBudgety.post('Paquete/DeleteHitoPaqueteByIdAndTipoHito/' + idPresupuesto + '/' + idTipoHito)
}

async function deleteById(id) {
  return await ApiBudgety.post('Paquete/Delete/' + id, null, {
    headers: {
      ACCION: MenusSistema.mantenedor_hito.accesos.remover_grupo_hito,
      MENU: MenusSistema.mantenedor_hito.id,
    },
  })
}
